import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { APP_BAR_HEIGHT, APP_BAR_DESKTOP_HEIGHT } from './constants';

export const useAppBarHeight = (): number => {
  const { breakpoints } = useTheme();
  const match = useMediaQuery(breakpoints.up('lg'));
  return match ? APP_BAR_DESKTOP_HEIGHT : APP_BAR_HEIGHT;
};
